import { Modal, Form, Button } from "react-bootstrap";
import { Formik } from "formik";
import {BiSave, BiX} from "react-icons/bi";
import {useLazyAddEditAccessGroupFacilitiesQuery} from "app/redux/Facility/facilityApi";
// import {getDefaultSelectedFromOptions} from "./DropDownModal";
import { useState, useEffect } from "react";

import MultiselectTreeCtrl from "app/views/dashboard/userDashboard/MultiselectTreeCtrl";
import {useLazyAddCustomPropertyUnitsQuery  } from "app/redux/AMS/amsApi";
import useFullPageLoader from "app/hooks/useFullPageLoader ";

export default function AddCustomPropertyUnitsModal(props) {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const initialState = {
    loginUserName: localStorage.getItem("loginUserName") ?? "",
    loginUserPersonId: localStorage.getItem("loginUserPersonId") ?? "",
    loginUserEmail: localStorage.getItem("loginUserEmail") ?? "",
  };
  const [addEditAccessGroupFacilities] = useLazyAddEditAccessGroupFacilitiesQuery();

  const [loading, setLoading] = useState(false);
  const { open,  eventObject, handleSubmit, closeDialog } = props;
  
  
  const [addCustomPropertyUnits] = useLazyAddCustomPropertyUnitsQuery();
  let selectedIncludePropUnits = [];

  const updateSelectedItems = (selectedItems) => {
    selectedIncludePropUnits = selectedItems;
  }


  const handleFormSubmit  = async () => {
        showLoader();
        let obj = {};
        obj["companyId"] = localStorage.getItem('CompanyId');
        if(eventObject.vendorAccessGroupId){
            obj.vendorAccessGroupId = eventObject.vendorAccessGroupId;
        }
        if(eventObject.accessGroupType){
            obj.accessType = eventObject.accessGroupType;
        }
        obj["createdBy"] = localStorage.getItem("loginUserPersonId") ?? "0";
        let objPropertyUnits = [];
        selectedIncludePropUnits.forEach((item) => {
            let tempObj = {};
            tempObj.id = item.ID;
            tempObj.name = item.Name;
            objPropertyUnits.push(tempObj);
        })
        obj.propertyUnits = objPropertyUnits;
       
        await addCustomPropertyUnits(obj).then((result) => {
            hideLoader()
            if(result.isSuccess){
                handleSubmit(eventObject);
                closeDialog(false);
            }
        }, error => {
        hideLoader();
        });
  };

  
  

  return (
    <Modal show={open} onHide={closeDialog} size="">
      <Formik
        enableReinitialize={true}
        initialValues={eventObject}
        onSubmit={handleFormSubmit}
        >
            
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => {
          return (
            <>
              <Modal.Header className="bg-primary text-white d-flex flex-wrap justify-content-between align-items-center">
                <h4 className="m-0 text-white">Legg til ny enhet</h4>
                <i className="i-Close-Window cursor-pointer text-18"
                onClick={() => closeDialog(false)}/>
              </Modal.Header>

              <Modal.Body>
                <Form onSubmit={handleSubmit}>
                  <Form.Group>
                      <Form.Label>Enheter</Form.Label>
                      {
                        // <MultiselectTreeCtrl refId={'include-propunits'} labelKey={'FacilityName'}   outSelectedItem={updateSelectedItems} options={propertyUnitDetails}></MultiselectTreeCtrl>
                        <MultiselectTreeCtrl refId={'include-propunits'}   outSelectedItem={updateSelectedItems} options={eventObject.propertyUnitDetails}></MultiselectTreeCtrl>
                      }

                  </Form.Group>
                </Form>
              </Modal.Body>
                <Modal.Footer className={''}>
                    <Button variant="secondary" onClick={() => closeDialog(false)}>
                        <BiX  size={17}></BiX>
                        Lukke
                    </Button>

                    <Button   onClick={handleFormSubmit} variant="primary"  >
                        <BiSave  size={17}></BiSave>   Lagre endringer
                    </Button>
                </Modal.Footer>
            </>
          );
        }}
      </Formik>
      {loader}
    </Modal>
  );
}




